import { INVESTMENT_PAGE_CHECK } from './constants';

function pageCheck(history) {
  return { type: INVESTMENT_PAGE_CHECK, payload: { history } };
}

export const investmentAction = {
  pageCheck,
};
